import { isFirefoxDefaultSearch } from '#pplx/frontend/apps/ask/browser/firefoxUtils.js';
import { isMaybeIncognitoComet } from '#pplx/frontend/apps/ask/comet-shared/cometUtils.js';
import { isComputerRoute } from '#pplx/frontend/apps/ask/layout/sidebar/core/shared/constants.js';
import { useBlockUpsellForEnterpriseConsent } from '#pplx/frontend/apps/ask/organization/hooks/useBlockUpsellForEnterpriseConsent.js';
import { isPartnershipCampaign } from '#pplx/frontend/apps/ask/partners/partnershipUtils.js';
import { useUserCapabilities } from '#pplx/frontend/apps/ask/queries/user-queries/useUserCapabilities.js';
import { useWebPlatform } from '#pplx/frontend/platform-components/useWebPlatform.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import { memo, useMemo } from 'react';
export const OmitUpsellIf = memo(function OmitUpsellIf({ isSamsungBrowser: omitIfInSamsungBrowser, isWindowsApp: omitIfInWindowsApp, isIPad: omitIfIsIPad, isComet: omitIfInComet, isFirefoxDefaultSearch: omitIfInFirefoxDefaultSearch, isPartnershipCampaign: omitIfInPartnershipCampaign, isGovernment: omitIfInGovernment, isEnterpriseWithoutConsent: omitIfEnterpriseWithoutConsent, isComputer: omitIfOnComputer, fallback, children, }) {
    const isComet = isMaybeIncognitoComet();
    const isFirefoxSearch = isFirefoxDefaultSearch();
    const isPartnership = isPartnershipCampaign();
    const { isGovernmentRequestOrigin } = useUserCapabilities();
    const { device: { isWindowsApp, isSamsungBrowser, isIPad }, } = useWebPlatform();
    const pathname = usePathname();
    const isOnComputerPath = isComputerRoute(pathname);
    const isLoadingProfile = isGovernmentRequestOrigin === undefined;
    const shouldBlockForEnterpriseConsent = useBlockUpsellForEnterpriseConsent();
    const isInOmittedPlatform = useMemo(() => {
        if (omitIfInComet && isComet) {
            return true;
        }
        if (omitIfInWindowsApp && isWindowsApp) {
            return true;
        }
        if (import.meta.env.VITE_IS_PERPLEXITY_DESKTOP_BUILD && omitIfInWindowsApp) {
            return true;
        }
        if (omitIfInSamsungBrowser && isSamsungBrowser) {
            return true;
        }
        if (omitIfIsIPad && isIPad) {
            return true;
        }
        if (omitIfInFirefoxDefaultSearch && isFirefoxSearch) {
            return true;
        }
        if (omitIfInPartnershipCampaign && isPartnership) {
            return true;
        }
        if (omitIfInGovernment) {
            // If profile is still loading, hide the upsell until we know for sure
            if (isLoadingProfile) {
                return true;
            }
            // If profile has loaded and user is from government origin, hide the upsell
            if (isGovernmentRequestOrigin) {
                return true;
            }
        }
        if (omitIfEnterpriseWithoutConsent && shouldBlockForEnterpriseConsent) {
            return true;
        }
        if (omitIfOnComputer && isOnComputerPath) {
            return true;
        }
        return false;
    }, [
        isComet,
        isWindowsApp,
        isSamsungBrowser,
        isIPad,
        omitIfInComet,
        omitIfInSamsungBrowser,
        omitIfInWindowsApp,
        omitIfIsIPad,
        omitIfInFirefoxDefaultSearch,
        isFirefoxSearch,
        omitIfInPartnershipCampaign,
        isPartnership,
        omitIfInGovernment,
        isGovernmentRequestOrigin,
        isLoadingProfile,
        omitIfEnterpriseWithoutConsent,
        shouldBlockForEnterpriseConsent,
        omitIfOnComputer,
        isOnComputerPath,
    ]);
    return isInOmittedPlatform ? (fallback ?? null) : children;
});
//# sourceMappingURL=OmitUpsellIf.js.map